<template>
  <div id="channer_tab2">
    <div class="content">
      <div class="content_tab">
        <orgTree></orgTree>
      </div>
    </div>
  </div>
</template>

<script>
import areaMap from "./areaMap";
import orgTree from "./orgTree";
export default {
  name: "tab2",
  data: function() {
    return {
      labelWidth: "100",
      labelClassName: "bg-white",
      tabPosition: "left",
      datasShop: [],
      defaultProps: {
        children: "children",
        label: "name"
      },
      datasShopFirst: ""
    };
  },
  created() {
    this.getDealerLevelShop();
  },
  methods: {
    //经销商层级关系概览
    getDealerLevelShop() {
      fetch({ url: "hcm/hcmShop/getDealerLevelShop", method: "get" }).then(
        res => {
          if (res.status == "10000") {
            this.datasShop = res.data.children;
            this.datasShopFirst = res.data.name;
          }
        }
      );
    }
  },
  components: { areaMap, orgTree }
};
</script>

<style lang="scss">
#channer_tab2 {
  .content_tab {
    height: 680px;
    width: 1160px;
    overflow: auto;
    box-sizing: border-box;
  }
  .el-tab-pane {
    height: 650px;
    position: relative;
  }
  .el-tabs__content {
    overflow: auto;
    padding-left: 30px;
  }
  .el-icon-caret-right {
    &:before {
      content: "+";
      color: #d9d9d9;
      font-size: 12px;
      display: inline-block;
    }
  }
  .is-leaf,
  .expanded {
    &:before {
      content: "-";
      color: #d9d9d9;
      font-size: 12px;
      display: inline-block;
    }
  }

  .el-tree-node__expand-icon.expanded {
    transform: rotate(0deg);
  }
  .el-tree-node__expand-icon.expanded,
  .el-tree-node__expand-icon.is-leaf,
  .el-icon-caret-right {
    border: 1px solid #d9d9d9;
    padding: 3px;
    margin-right: 5px;
    width: 6px;
    height: 6px;
    text-align: center;
    line-height: 6px;
    border-radius: 2px;
  }
  .el-tree > div > div:first-child {
    margin: 15px 0 5px 0;
    font-size: 16px;
    color: #108cee;
  }

  .el-tabs__header {
    height: 699px;
  }
  .div_content {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding: 8px 10px;
    border: 1px solid #108cee;
    border-radius: 6px;
  }

  .el-tabs__item.is-active {
    color: #108cee;
    background: #e7f3fd;
  }
  .el-tabs--left .el-tabs__active-bar.is-left,
  .el-tabs--left .el-tabs__active-bar.is-right,
  .el-tabs--right .el-tabs__active-bar.is-left,
  .el-tabs--right .el-tabs__active-bar.is-right {
    width: 4px;
  }
  .content {
    margin: 20px;
  }
  .content_tab {
    width: 100%;
    overflow: auto;
    .shop_name {
      margin-top: 17px;
      font-size: 16px;
      color: #666;
    }
    .tab_tree {
      margin-top: 30px;
    }
  }
}
@media screen and (max-width: 1400px) {
  /*.el-tab-pane{*/
  /*    height: 500px!important;*/
  /*}*/
}
</style>
